import { Button, IconButton, Modal } from 'components/core';
import { MdClose } from 'react-icons/md';
import { Styled } from '.';
import { useI18n } from 'contexts/i18n';

export const ITeroProposalNotificationModal = ({
  onClose,
  onAccept,
}: {
  onClose: () => void;
  onAccept: () => void;
}) => {
  const  i18n = useI18n();
  return (
    <Modal overlaysize={'medium'}>
      <Styled.ITeroProposalNotificationContainer>
        <Styled.ModalHeader>
          <div></div>
          <IconButton onClick={onClose} showBorder={false} size="xs">
            <MdClose onClick={onClose} />
          </IconButton>
        </Styled.ModalHeader>
        <Styled.ModalBody>
          {i18n['Your iTero™ intraoral scanner Proposal is ready for your review.']}
        </Styled.ModalBody>
        <Styled.ModalFooter>
          <Button onClick={onAccept}>{i18n['View Your Proposal']}</Button>
        </Styled.ModalFooter>
      </Styled.ITeroProposalNotificationContainer>
    </Modal>
  );
};
